import { jsx as _jsx } from "react/jsx-runtime";
import "./CarouselMessage.scss";
export const CarouselMessage = () => {
    return (_jsx("div", { className: "navbar-carousel-container", children: _jsx("div", { id: "navbar-carousel", className: "navbar-carousel-track", children: Array.from({ length: 10 }).map((_, index) => (_jsx("div", { className: "navbar-carousel-group", children: _jsx("p", { children: "Reconociendo la labor del campo - \u00A1Env\u00EDo gratis a partir de $150,000!" }) }, index))) }) }));
};
